var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { TAG } from '@heimdallr-sdk/types';
export var hasConsole = function () { return typeof console !== 'undefined'; };
export var formateUrlPath = function (host, path) {
    return "".concat(/^http(s|):\/\//.test(host || '') ? host : "//".concat((host || '').replace(/^http(s|):\/\//, '')), "/").concat((path || '')[0] === '/' ? path.substring(1) : path);
};
export var getUrlPath = function (url) {
    var path = "".concat((url || '').replace(/^http(s|):/, '').split('?')[0]);
    var endIndex = path.length - 1;
    return path[endIndex] === '/' ? path.substring(0, endIndex) : path;
};
export function setUrlQuery(url, query) {
    if (query === void 0) { query = {}; }
    var queryArr = [];
    Object.keys(query).forEach(function (k) {
        queryArr.push("".concat(k, "=").concat(query[k]));
    });
    return "".concat(url).concat(url.indexOf('?') !== -1 ? '&' : '?').concat(queryArr.join('&'));
}
export function getDeepPropByDot(keyPath, obj) {
    if (!keyPath || !obj) {
        return null;
    }
    var copyTarget = __assign({}, obj);
    var paths = keyPath.split('.');
    var result = copyTarget;
    for (var _i = 0, paths_1 = paths; _i < paths_1.length; _i++) {
        var key = paths_1[_i];
        var value = result[key];
        if (!value) {
            console.warn(TAG, "".concat(key, " does not exist"));
            return null;
        }
        result = value;
    }
    return result;
}
export function obj2query(data) {
    return Object.keys(data).reduce(function (pre, cur) {
        var val = data[cur];
        pre += "".concat(pre ? '&' : '').concat(cur, "=").concat(typeof val === 'object' ? JSON.stringify(val) : val);
        return pre;
    }, '');
}
